module.exports = __webpack_public_path__ + "img/icon_close_gray.c2d6a615.svg";